export const AUTH_ERROR = "AUTH_ERROR";
export const CHANGE_USER_COMPANY_LEVEL = "CHANGE_USER_COMPANY_LEVEL";
export const CHANGE_USER_CUSTOM_RESOURCE_LIMITS =
    "CHANGE_USER_CUSTOM_RESOURCE_LIMITS";
export const REMOVE_LOADING = "REMOVE_LOADING";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const RESET_AUTH_TYPE = "RESET_AUTH_TYPE";
export const SET_COOKIE_CONSENT = "SET_COOKIE_CONSENT";
export const SET_LOADING = "SET_LOADING";
export const SET_USER = "SET_USER";
export const TOGGLE_2FA_ENABLE = "TOGGLE_2FA_ENABLE";
export const TOGGLE_2FA_VERIFICATION = "TOGGLE_2FA_VERIFICATION";
